<template>
    <span class="draggable-icon-wrapper">
        <icon icon="suitcase" color="#fff" class="draggable-icon--small"></icon>
        <span class="draggable-fleet-counter">{{ value.organizationCounter }}</span>
        <icon icon="truck-solid" color="#fff" class="draggable-icon--small draggable-icon--next"></icon>
        <span class="draggable-fleet-counter">{{ value.fleetsCounter }}</span>
        <icon icon="event-car" color="#fff" class="draggable-icon--small draggable-icon--next"></icon>
        <span class="draggable-fleet-counter">{{ value.vehicleCounter }}</span>
        <icon icon="device" color="#fff" class="draggable-icon--small draggable-icon--next"></icon>
        <span class="draggable-fleet-counter">{{ value.devicesCounter }}</span>
    </span>
</template>

<script>
import Icon from '@/components/atoms/Icon'
import OrganizationTree from '@/models/OrganizationTree'

export default {
    name: 'TreeViewItemOrganization',
    props: {
        value: {
            type: OrganizationTree
        }
    },
    watch: {
        value: {
            handler: function (value, oldVal) {
                // console.debug('TreeViewItemOrganization::value', value, oldVal)
            },
            deep: true
        }
    },
    components: {
        Icon
    }
}
</script>

<style scoped lang="scss">
.draggable-icon {
    &--small {
        background-color: $secondary-default;
        padding: 5px;
        height: 20px;
        width: 20px;
        border-radius: 7px;

        @media (min-width: 1200px) {
            height: 23px;
            width: 29px;
        }
    }

    &--next {
        margin-left: 5%;
        margin-top: 2px;
        margin-bottom: 2px;

        @include media-breakpoint-up(lg) {
            margin-left: 4%;
        }
    }
}

.draggable-fleet-counter {
    font-size: 12px;
    font-weight: 700;
    margin-left: 1px;

    @media (min-width: 1200px) {
        margin-left: 5px
    }
}

.isMenuActive .tree {
    @media (min-width: 1200px) {
        .draggable-icon {
            &--small {
                height: 18px;
                width: 18px;
            }
        }
        .draggable-fleet-counter {
            margin-left: 1px;
        }
    }
    @media (min-width: 1440px) {
        .draggable-icon {
            &--small {
                height: 20px;
                width: 20px;
            }
        }
    }
    @media (min-width: 1700px) {
        .draggable-icon {
            &--small {
                height: 23px;
                width: 29px;
            }
        }
        .draggable-fleet-counter {
            margin-left: 3px;
        }
    }
}
</style>
